const DAY_MS = 24 * 60 * 60 * 1000;

function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/** Whole calendar days from `today` to `dueDate` - negative once the date has passed. */
export function daysUntil(dueDate: string | Date, today: Date = new Date()): number {
  return Math.round((startOfDay(new Date(dueDate)).getTime() - startOfDay(today).getTime()) / DAY_MS);
}

/** How far a payment's due date is from today: "Today", "Tomorrow", "In 3 days", "Yesterday", "3 days ago". */
export function dueDayLabel(dueDate: string | Date, today: Date = new Date()): string {
  const days = daysUntil(dueDate, today);
  if (days === 0) return 'Today';
  if (days === 1) return 'Tomorrow';
  if (days === -1) return 'Yesterday';
  return days > 0 ? `In ${days} days` : `${-days} days ago`;
}
